import { useAppSelector } from "../../store/hooks";
import drawerStyles from "../../styles/drawer.module.css";
import labels from "../../utils/labels";
import ColorChip from "../UI/chips/ColorChip";
import InfoBoxGreyBlackColumns from "./InfoBoxGreyBlackColumns";
import InfoBoxRow from "./InfoBoxRow";

const GeneralTaskInfoBox = () => {
  const selectedTask = useAppSelector(
    (state) => state.drawerSlice.selectedTask,
  );

  const isHighPriority = selectedTask?.task.priority === "HIGH";
  const priorityLabel = isHighPriority ? labels.high : labels.normal;
  const priorityColor = isHighPriority
    ? "var(--col-error-3)"
    : "var(--col-interaction-tertiary)";

  return (
    <div className={drawerStyles.generalTaskInfoBox}>
      {selectedTask && (
        <>
          <InfoBoxRow title={labels.priority}>
            <ColorChip text={priorityLabel} color={priorityColor} />
          </InfoBoxRow>
          <InfoBoxRow title={labels.citizenDetails}>
            <InfoBoxGreyBlackColumns
              key={labels.citizen}
              firstColumn={labels.citizen}
              secondColumn={selectedTask.task.client.description}
            />
            <InfoBoxGreyBlackColumns
              key={labels.address}
              firstColumn={labels.address}
              secondColumn={
                <span>{`${selectedTask.task.address}, ${selectedTask.task.postalCode} ${selectedTask.task.district}`}</span>
              }
            />
          </InfoBoxRow>
          <InfoBoxRow title={labels.skillRequirement}>
            <InfoBoxGreyBlackColumns
              key={labels.skills}
              firstColumn={labels.skills}
              secondColumn={selectedTask.task.requiredSkills}
            />
          </InfoBoxRow>
        </>
      )}
    </div>
  );
};

export default GeneralTaskInfoBox;
